import {
    each
} from 'App/lib/util';
import DomComponent from '../../lib/domComponent';

const PAGER_SELECTOR = '[data-page]';

export default class Pager extends DomComponent {
    static selector = '[data-js-pager]';
    totalPages;
    page;

    constructor(el, opts) {
        super(el);

        this.perPage = opts.perPage || 25;
        this.page = opts.initialPage || 1;

        this.prevButton = this.el.querySelector('[data-prev]');
        this.nextButton = this.el.querySelector('[data-next]');
        this.pagesWrapper = this.el.querySelector('[data-pages]');


        this.pagesWrapper.addEventListener('click', this.handlePageClick.bind(this));
        this.nextButton.addEventListener('click', this.handleNextClick.bind(this));
        this.prevButton.addEventListener('click', this.handlePrevClick.bind(this));

        setTimeout(() => {
            this.loaded();
        });
    }

    update(page, total) {
        this.totalPages = Math.ceil(total / this.perPage);
        this.page = page;

        // Only show the pager if there are at least 2 pages of data, or if the currently visible
        // page is not the first one.
        let showPager = this.totalPages > 1 || page > 1;
        if(showPager) {
            this.renderPages();
            this.el.style.display = 'flex';
        }
        else {
            this.el.style.display = 'none';
        }
    }

    renderPages() {
        this.pagesWrapper.innerHTML = "";
        let pagerLinks = [];

        let i = this.totalPages;
        while (i--) {
            const num = i + 1;
            pagerLinks[i] = this.pagerButton(i === (this.page - 1) ? "current" : "", num, num)
        }

        if (pagerLinks.length > 5) {
            let pager;

            pager = this.truncate(
                pagerLinks,
                this.page,
                this.totalPages,
                1,
                "&hellip;"
            );

            pagerLinks = pager;
        }

        pagerLinks.forEach(page => this.pagesWrapper.appendChild(page));

    }

    handlePageClick(e) {

        const $target = $(e.target);

        if (!$target.is(PAGER_SELECTOR)) {
            return;
        }

        const targetPage = $(e.target).data('page');

        if (targetPage <= 1) {
            this.prevButton.classList.add('disabled')
        } else {
            this.prevButton.classList.remove('disabled')
        }
        if (targetPage >= this.totalPages) {
            this.nextButton.classList.add('disabled');
        } else {
            this.nextButton.classList.remove('disabled');
        }

        this.emit('page:change', targetPage);
    }

    handleNextClick() {

        const targetPage = this.page + 1;

        if (targetPage >= this.totalPages) {
            this.nextButton.classList.add('disabled');
        } else {
            this.nextButton.classList.remove('disabled');
        }

        this.prevButton.classList.remove('disabled');

        this.emit('page:change', targetPage);
    }

    handlePrevClick() {

        const targetPage = this.page - 1;
        this.emit('page:change', targetPage);

        if (targetPage <= 1) {
            this.prevButton.classList.add('disabled')
        } else {
            this.prevButton.classList.remove('disabled')
        }

        this.nextButton.classList.remove('disabled')

    }

    createElement(a, b) {
        const d = document.createElement(a);
        if (b && "object" == typeof b) {
            let e;
            for (e in b) {
                if ("html" === e) {
                    d.innerHTML = b[e];
                } else {
                    d.setAttribute(e, b[e]);
                }
            }
        }
        return d
    }

    // this algo was snagged from simple-datatables: https://github.com/fiduswriter/Simple-DataTables
    truncate(a, b, c, d, ellipsis) {
        d = d || 2
        let j
        const e = 2 * d
        let f = b - d
        let g = b + d
        const h = []
        const i = []
        if (b < 4 - d + e) {
            g = 3 + e
        } else if (b > c - (3 - d + e)) {
            f = c - (2 + e)
        }
        for (let k = 1; k <= c; k++) {
            if (1 == k || k == c || (k >= f && k <= g)) {
                const l = a[k - 1]
                h.push(l)
            }
        }
        each(h, c => {
            const d = c.getAttribute("data-page")
            if (j) {
                const e = j.getAttribute("data-page")
                if (d - e == 2) i.push(a[e])
                else if (d - e != 1) {
                    const f = this.createElement("span", {
                        class: "pager__page ellipsis",
                        html: ellipsis
                    })
                    i.push(f)
                }
            }
            i.push(c)
            j = c
        })

        return i
    }

    /**
     * Create button helper
     * @param  {String}   c
     * @param  {Number}   p
     * @param  {String}   t
     * @return {Object}
     */
    pagerButton(c, p, t) {
        return this.createElement("a", {
            class: `pager__page ${c}`,
            //href: "#",
            'data-page': p,
            html: t
        })
    }



}
